import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { GUIDES, PAGE_SEO, breadcrumb } from "../data.js";
import CtaBand from "../components/CtaBand.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const VOCI = [
  {
    t: "Canone del software",
    d: "È la voce più visibile: quasi tutti i gestionali oggi funzionano in abbonamento mensile, non con licenza una tantum. Il prezzo varia soprattutto in base a cosa è incluso — non solo alla \"fascia\" del piano.",
  },
  {
    t: "Sito web di prenotazione",
    d: "Alcuni gestionali gestiscono solo il back-office (flotta, calendario, contratti) e il sito per i clienti va costruito e pagato a parte, con un web designer o un altro strumento. Altri, come NoleggioinCloud, includono il sito di prenotazione nel canone: prima di confrontare due prezzi, verifica se stai confrontando la stessa cosa.",
  },
  {
    t: "Dominio personalizzato e hosting",
    d: "Avere il sito su un tuo dominio (es. tuonoleggio.it) invece che su un sottodominio del fornitore ha un costo, che alcuni gestionali includono nei piani più alti e altri fatturano separatamente ogni anno.",
  },
  {
    t: "Commissioni sui pagamenti online",
    d: "Se accetti carte online, oltre al canone del gestionale c'è la commissione del gestore di pagamento (es. Stripe) su ogni transazione — questa non è mai \"inclusa\" da nessun fornitore, è un costo terzo, ma va messo in conto nel budget mensile.",
  },
  {
    t: "Numero di veicoli e di operatori",
    d: "Molti gestionali fanno pagare di più superata una certa soglia di veicoli caricabili o di account admin: se prevedi di crescere, controlla cosa succede quando superi il limite del piano che stai valutando, non solo il prezzo di partenza.",
  },
  {
    t: "Assistenza e SLA",
    d: "Un piano più economico spesso significa assistenza più lenta (es. risposta entro 72h invece che 24h) e nessuna garanzia formale di uptime. Per un'attività che vive di prenotazioni online, un sito fermo per ore ha un costo reale anche se non compare in fattura.",
  },
];

const BC_ITEMS = [{ name: "Quanto costa un gestionale", path: "/quanto-costa-un-gestionale-per-autonoleggio" }];

export default function QuantoCostaGestionale({ go }) {
  useAnim();
  useSEO({
    ...PAGE_SEO["quanto-costa-un-gestionale-per-autonoleggio"],
    schema: breadcrumb(BC_ITEMS),
  });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Guida</div>
          <h1 className="h2" style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)" }}>
            Quanto costa un <mark>gestionale per autonoleggio</mark>
          </h1>
          <p className="lead" style={{ marginTop: ".65rem" }}>
            Il canone mensile è solo una parte del prezzo. Ecco le voci da
            confrontare davvero prima di scegliere.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--bg)" }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: "2rem" }}>
            Confrontare due gestionali guardando solo il prezzo mensile porta
            spesso a scoperte sgradite dopo l'attivazione: dominio a parte,
            sito da costruire altrove, limiti sui veicoli caricabili.
            Ecco le voci di costo che incidono davvero sul totale.
          </p>

          {VOCI.map((v) => (
            <div key={v.t} className="an" style={{ marginBottom: "1.75rem" }}>
              <h2 style={{ fontSize: "1.15rem", marginBottom: ".4rem" }}>{v.t}</h2>
              <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75 }}>{v.d}</p>
            </div>
          ))}

          <div className="an" style={{ marginTop: "2.5rem", padding: "1.5rem", borderRadius: 14, background: "var(--bg2, #f6f8fc)" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".5rem" }}>
              Quanto costa NoleggioinCloud
            </h2>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: ".75rem" }}>
              Il piano Base parte da 34,99€/mese (fino a 10 veicoli, auto e moto, sito di prenotazione e pagamenti Stripe inclusi).
              Il piano Pro è 89,99€/mese (fino a 40 veicoli, codici sconto, statistiche e admin illimitati);
              il Business Pro è 169€/mese e aggiunge veicoli illimitati, dominio personalizzato,
              hosting dedicato e personalizzazione completa del sito. Prova gratuita di
              14 giorni, senza carta di credito.
            </p>
            <Link to="/prezzi" style={{ fontWeight: 600 }}>
              Vedi il confronto completo dei piani →
            </Link>
          </div>

          <div className="an" style={{ marginTop: "2rem" }}>
            <h2 style={{ fontSize: "1.05rem", marginBottom: ".5rem" }}>Approfondisci</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 2 }}>
              {GUIDES.filter((g) => g.slug !== "quanto-costa-un-gestionale-per-autonoleggio").map((g) => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`}>{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand go={go} />
    </>
  );
}
